export function decodeImageService(content: string, fileName: string): string | undefined {
    if (content && fileName) {
        const contentType = fileName.split('.')[1];
        return `data:image/${contentType};base64,${content}`;
    }
    return;
}
